import { UnauthenticatedAPI } from '../../core-apis/src/apis/config/api/unauthenticatedApi'

const WIGGOT_BACKOFFICE_LEGACY = process.env.WIGGOT_BACKOFFICE_LEGACY ?? ''

class BackOfficeLegacyApiAuth extends UnauthenticatedAPI {
  constructor() {
    super({
      domain: WIGGOT_BACKOFFICE_LEGACY
    })
  }
}

export const backOfficeLegacyApiAuth = new BackOfficeLegacyApiAuth()
